import React from 'react';
import localization from './localization';

const Text = props => (
    <span className={props.className || ''}>
        {localization.getText(props.children)}
    </span>
);

export default Text;



// WEBPACK FOOTER //
// ./src/Text.js